// extracted by mini-css-extract-plugin
export var fadeIn = "_kh-1";
export var modalContent = "_kh-3";
export var overlay = "_kh-0";
export var popoverContent = "_kh-2";
export var results = "_kh-5";
export var searchInputWrapper = "_kh-4";